import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'wfm-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent implements AfterViewInit, OnChanges {
  @Input() show?: boolean = true;
  @Input() size?: number = 40;
  @Input() color?: string;

  @ViewChild('spinner') spinner: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.changeSpinnerStyles({
      size: this.size,
      color: this.color
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.changeSpinnerStyles({
      size: changes.size && !changes.size.firstChange && changes.size.currentValue,
      color: changes.color && !changes.color.firstChange && changes.color.currentValue
    });
  }

  private changeSpinnerStyles({ size, color }) {
    if (this.spinner) {
      if (size) {
        this.renderer.setStyle(this.spinner.nativeElement, 'width', size + 'px');
        this.renderer.setStyle(this.spinner.nativeElement, 'height', size + 'px');
      }

      if (color) {
        this.renderer.setStyle(this.spinner.nativeElement, 'color', color);
      }
    }
  }
}
